export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 2,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 3,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 4,
				text: "The lecturer was able to make complicated subjects understandable.",
			},
			{
				id: 5,
				text: "The learning objective was clear to me.",
			},
			{
				id: 6,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 7,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 8,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 9,
				text: "I was already interested in the subject of the course before I signed up for it.",
			},
			{
				id: 10,
				text: "The topic of the course is relevant.",
			},
			{
				id: 11,
				text: "I believe that I have learned important facts in this course.",
			},
			{
				id: 12,
				text: "The topic of the course is relevant for my future professional goals.",
			},
			{
				id: 13,
				text: "The difficulty of the content was adequate.",
			},
			{
				id: 14,
				text: "The amount of the content was adequate.",
			},
			{
				id: 15,
				text: "The pace of the course was adequate.",
			},
			{
				id: 16,
				text: "The requirements of the course were adequate.",
			},
			{
				id: 17,
				text: "The amount of time required for the course (including preparation and follow-up) was appropriate.",
			},
			{
				id: 18,
				text: "The course was too difficult for me.",
			},
			{
				id: 19,
				text: "This course demanded too little from me.",
			},
			{
				id: 20,
				text: "Overall, this was a good course.",
			},
			{
				id: 21,
				text: "I learned a lot in this course.",
			},
			{
				id: 22,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 23,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 24,
				text: "Further remarks regarding the course (praise/criticism/proposal)",
			},
		],
	},
	{
		type: "age",
		id: 3,
		items: [
			{
				id: 25,
				text: "Age: ",
			},
		],
	},
];
